import { Component } from 'vue-property-decorator';
import { BaseComponent } from '../base-component';

@Component
export class WmsGlobalMeta extends BaseComponent {
	block = this.$store.componentsPage.blocks.find(b => b.template === 'global-meta');

	mounted() {
		const scriptsHtml = this.getText('scripts');
		const el = document.createElement('div');
		el.innerHTML = scriptsHtml;

		const scripts = Array.from(el.getElementsByTagName('script'));

		for (let script of scripts) {
			const newScript = document.createElement('script');
			newScript.type = 'text/javascript';

			if (script.attributes) {
				Array.from(script.attributes).forEach(attr => {
					newScript.setAttribute(attr.name, attr.value);
				})
			}

			if (!script.src) {
				newScript.textContent = script.textContent;
			}

			el.removeChild(script);
			document.body.appendChild(newScript);
		}
	}
}

export default WmsGlobalMeta;
